import React, { useState } from "react";
import "./Contact.css";
import { Link, useNavigate } from "react-router-dom";
import contimg from "./../images/contact.svg";
import {motion,AnimatePresence} from "framer-motion"
import axios from "axios";
import { alert } from "@material-tailwind/react";
import Media from "./Media";
import {ToastContainer,toast} from "react-toastify"
function Contact() {
 const [name,setName]=useState("")
 const [email,setEmail]=useState("")
 const [phone,setPhone]=useState("")
 const [country,setCountry]=useState("")
 const [message,setMessage]=useState("")
 const [response,setResponse]=useState(null)
 console.log(name)
 console.log(email)
 const popUp = () =>
   toast("Thank you for visiting us!, we will contact you as soon as possible.");
const handlesubmit = (e) => {
  e.preventDefault();
  axios
    .post("https://back.waratechnology.com/api/client/setclient", {
      name,
      email,
      phone,
      country,
      message,
    })
    .then((res) => {
      console.log(res.data.msg);

      setName("");
      setEmail("");
      setPhone("");
      setCountry("");
      setMessage("");
      popUp();
    })
    .catch((err) => {
      console.log(err);
    });
};

  return (
    // <div id="contact" className="contact_area m-0 w-full py-24 pb-120 ">
    //   {/* bg-gradient-to-r from-blue-200 to-orange-200 */}
    //   <div classNameName="block md:flex">
    //     <div className="contact_image flex items-center w-full">
    //       <div className="image lg:pr-13 border border-gray-600 border-right">
    //         <img src={contimg} alt="about" />
    //       </div>
    //     </div>
    //     {/* about image  */}

    //     <div className="container w-full">
    //       <div className="row">
    //         <div className="w-full lg:w-3/4">
    //           <div className="contact_wrapper mt-11">
    //             <div className="section_title pb-4">
    //               <h4 classNameName="text-4xl font-bold">Get In Touch</h4>
    //               <p>Please feel free to contact us!</p>
    //             </div>
    //             {/* section title */}

    //             <div className="contact_form">
    //               <form id="contact-form">
    //                 <div className="row">
    //                   <div className="w-full md:w-1/2">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <input
    //                           name="name"
    //                           id="name"
    //                           type="text"
    //                           placeholder="Your Name"
    //                           className="w-full rounded-md py-4 px-6 border border-solid border-body-color"
    //                         />
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                   <div className="w-full md:w-1/2">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <input
    //                           name="phone"
    //                           id="phone"
    //                           type="phone"
    //                           placeholder="Your Phone"
    //                           className="w-full rounded-md py-4 px-6 border border-solid border-body-color"
    //                         />
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                   <div className="w-full md:w-1/2">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <input
    //                           name="email"
    //                           id="email"
    //                           type="email"
    //                           placeholder="Your Email"
    //                           className="w-full rounded-md py-4 px-6 border border-solid border-body-color"
    //                         />
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                   <div className="w-full md:w-1/2">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <input
    //                           name="country"
    //                           id="country"
    //                           type="country"
    //                           placeholder="Your Country"
    //                           className="w-full rounded-md py-4 px-6 border border-solid border-body-color"
    //                         />
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                   <div className="w-full">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <textarea
    //                           name="message"
    //                           id="message"
    //                           placeholder="Message"
    //                           rows="5"
    //                           className="w-full rounded-md py-4 px-6 border border-solid border-body-color resize-none"
    //                         ></textarea>
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                   <p className="form-message mx-3"></p>
    //                   <div className="w-full">
    //                     <div className="mx-3">
    //                       <div className="single_form mt-8">
    //                         <button
    //                           type="submit"
    //                           classNameName="bg-orange-500 hover:bg-orange-600 active:bg-orange-700 focus:outline-none focus:ring focus:ring-orange-300 text-x py-1 px-4 border rounded-full "
    //                         >
    //                           Submit
    //                         </button>
    //                       </div>
    //                       {/* single form  */}
    //                     </div>
    //                   </div>
    //                 </div>
    //                 {/* row  */}
    //               </form>
    //             </div>
    //             {/* contact form  */}
    //           </div>
    //           {/* contact wrapper  */}
    //         </div>
    //       </div>
    //       {/* <!-- row --> */}
    //     </div>
    //     {/* <!-- container --> */}
    //   </div>
    // </div>
    <AnimatePresence mode="wait">
      <div
        initial={{ y: 10, opacity: 1 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -10, opacity: 1 }}
        transition={{ duration: 0.2 }}
        className="pt-6 max-w-full h-full max-lg:max-w-full mx-auto bg-[#F9FAFB] rounded-lg"
      >
        <div className="grid lg:grid-cols-2 items-center gap-14 sm:p-8 p-4 font-[sans-serif]">
          <div className="mt-5 md:mt-8">
            <p className="text-lg lg:text-2xl font-semibold text-gray-800 pt-0 md:pt-2 md:pb-10 font-play ">
              We'd love to hear about your project and provide help.
            </p>
            <div className="contact_image hidden md:flex items-center md:w-full mt-4">
              <div className="image lg:pr-13 mt-4">
                <img src={contimg} alt="about" />
              </div>
            </div>

            {/* <ul className="flex mt-12 space-x-4">
              <li className="bg-[#f0b134] hover:bg-[#f7c664] h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                <Link to="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    fill="#000"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M6.812 13.937H9.33v9.312c0 .414.335.75.75.75l4.007.001a.75.75 0 0 0 .75-.75v-9.312h2.387a.75.75 0 0 0 .744-.657l.498-4a.75.75 0 0 0-.744-.843h-2.885c.113-2.471-.435-3.202 1.172-3.202 1.088-.13 2.804.421 2.804-.75V.909a.75.75 0 0 0-.648-.743A26.926 26.926 0 0 0 15.071 0c-7.01 0-5.567 7.772-5.74 8.437H6.812a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75zm.75-3.999h2.518a.75.75 0 0 0 .75-.75V6.037c0-2.883 1.545-4.536 4.24-4.536.878 0 1.686.043 2.242.087v2.149c-.402.205-3.976-.884-3.976 2.697v2.755c0 .414.336.75.75.75h2.786l-.312 2.5h-2.474a.75.75 0 0 0-.75.75V22.5h-2.505v-9.312a.75.75 0 0 0-.75-.75H7.562z"
                      data-original="#000000"
                    />
                  </svg>
                </Link>
              </li>
              <li className="bg-[#f0b134] hover:bg-[#f7c664] h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                <Link to="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    fill="#000"
                    viewBox="0 0 511 512"
                  >
                    <path
                      d="M111.898 160.664H15.5c-8.285 0-15 6.719-15 15V497c0 8.285 6.715 15 15 15h96.398c8.286 0 15-6.715 15-15V175.664c0-8.281-6.714-15-15-15zM96.898 482H30.5V190.664h66.398zM63.703 0C28.852 0 .5 28.352.5 63.195c0 34.852 28.352 63.2 63.203 63.2 34.848 0 63.195-28.352 63.195-63.2C126.898 28.352 98.551 0 63.703 0zm0 96.395c-18.308 0-33.203-14.891-33.203-33.2C30.5 44.891 45.395 30 63.703 30c18.305 0 33.195 14.89 33.195 33.195 0 18.309-14.89 33.2-33.195 33.2zm289.207 62.148c-22.8 0-45.273 5.496-65.398 15.777-.684-7.652-7.11-13.656-14.942-13.656h-96.406c-8.281 0-15 6.719-15 15V497c0 8.285 6.719 15 15 15h96.406c8.285 0 15-6.715 15-15V320.266c0-22.735 18.5-41.23 41.235-41.23 22.734 0 41.226 18.495 41.226 41.23V497c0 8.285 6.719 15 15 15h96.403c8.285 0 15-6.715 15-15V302.066c0-79.14-64.383-143.523-143.524-143.523zM466.434 482h-66.399V320.266c0-39.278-31.953-71.23-71.226-71.23-39.282 0-71.239 31.952-71.239 71.23V482h-66.402V190.664h66.402v11.082c0 5.77 3.309 11.027 8.512 13.524a15.01 15.01 0 0 0 15.875-1.82c20.313-16.294 44.852-24.907 70.953-24.907 62.598 0 113.524 50.926 113.524 113.523zm0 0"
                      data-original="#000000"
                    />
                  </svg>
                </Link>
              </li>
              <li className="bg-[#f0b134] hover:bg-[#f7c664] h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                <Link to="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    fill="#000"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 9.3a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 0 0 0-5.4Zm0-1.8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm5.85-.225a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0ZM12 4.8c-2.227 0-2.59.006-3.626.052-.706.034-1.18.128-1.618.299a2.59 2.59 0 0 0-.972.633 2.601 2.601 0 0 0-.634.972c-.17.44-.265.913-.298 1.618C4.805 9.367 4.8 9.714 4.8 12c0 2.227.006 2.59.052 3.626.034.705.128 1.18.298 1.617.153.392.333.674.632.972.303.303.585.484.972.633.445.172.918.267 1.62.3.993.047 1.34.052 3.626.052 2.227 0 2.59-.006 3.626-.052.704-.034 1.178-.128 1.617-.298.39-.152.674-.333.972-.632.304-.303.485-.585.634-.972.171-.444.266-.918.299-1.62.047-.993.052-1.34.052-3.626 0-2.227-.006-2.59-.052-3.626-.034-.704-.128-1.18-.299-1.618a2.619 2.619 0 0 0-.633-.972 2.595 2.595 0 0 0-.972-.634c-.44-.17-.914-.265-1.618-.298-.993-.047-1.34-.052-3.626-.052ZM12 3c2.445 0 2.75.009 3.71.054.958.045 1.61.195 2.185.419A4.388 4.388 0 0 1 19.49 4.51c.457.45.812.994 1.038 1.595.222.573.373 1.227.418 2.185.042.96.054 1.265.054 3.71 0 2.445-.009 2.75-.054 3.71-.045.958-.196 1.61-.419 2.185a4.395 4.395 0 0 1-1.037 1.595 4.44 4.44 0 0 1-1.595 1.038c-.573.222-1.227.373-2.185.418-.96.042-1.265.054-3.71.054-2.445 0-2.75-.009-3.71-.054-.958-.045-1.61-.196-2.185-.419A4.402 4.402 0 0 1 4.51 19.49a4.414 4.414 0 0 1-1.037-1.595c-.224-.573-.374-1.227-.419-2.185C3.012 14.75 3 14.445 3 12c0-2.445.009-2.75.054-3.71s.195-1.61.419-2.185A4.392 4.392 0 0 1 4.51 4.51c.45-.458.994-.812 1.595-1.037.574-.224 1.226-.374 2.185-.419C9.25 3.012 9.555 3 12 3Z"></path>
                  </svg>
                </Link>
              </li>
            </ul> */}
          </div>

          <div className="bg-gray-100 p-6 pt-0 md:p-6 rounded-lg">
            <h1 className="text-2xl md:text-4xl text-center font-bold text-black md:mt-8 font-play">
              Get in Touch
            </h1>
            <form className="mt-4 space-y-4" onSubmit={handlesubmit}>
              <input
                type="text"
                placeholder="Name"
                className="w-full rounded-lg py-3 px-4 text-gray-800 text-sm outline-[#f7c664]"
                onChange={(e) => setName(e.target.value)}
              />
              <input
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Email"
                className="w-full rounded-lg py-3 px-4 text-gray-800 text-sm outline-[#f7c664]"
              />
              <input
                onChange={(e) => setCountry(e.target.value)}
                type="text"
                placeholder="country"
                className="w-full rounded-lg py-3 px-4 text-gray-800 text-sm outline-[#f7c664]"
              />
              <input
                onChange={(e) => setPhone(e.target.value)}
                type="tel"
                placeholder="phone"
                className="w-full rounded-lg py-3 px-4 text-gray-800 text-sm outline-[#f7c664]"
              />
              <textarea
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
                rows="6"
                className="w-full rounded-lg px-4 text-gray-800 text-sm pt-3 outline-[#f7c664]"
              ></textarea>

              <button
                type="submit"
                className="text-gray-900 bg-[#f7b53b] hover:bg-[#ed8936] tracking-wide rounded-lg text-sm px-4 py-3 flex items-center justify-center w-full !mt-6"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16px"
                  height="16px"
                  fill="#000"
                  className="mr-2"
                  viewBox="0 0 548.244 548.244"
                >
                  <path
                    fill-rule="evenodd"
                    d="M392.19 156.054 211.268 281.667 22.032 218.58C8.823 214.168-.076 201.775 0 187.852c.077-13.923 9.078-26.24 22.338-30.498L506.15 1.549c11.5-3.697 24.123-.663 32.666 7.88 8.542 8.543 11.577 21.165 7.879 32.666L390.89 525.906c-4.258 13.26-16.575 22.261-30.498 22.338-13.923.076-26.316-8.823-30.728-22.032l-63.393-190.153z"
                    clip-rule="evenodd"
                    data-original="#000000"
                  />
                </svg>
                Send Message
              </button>
            </form>
            <ToastContainer />
          </div>
        </div>
        {/* <Media /> */}
      </div>
    </AnimatePresence>
  );
}

export default Contact;
